import {View} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback} from "react";
import {Category} from "./types";
import {GridItem, GridViewContent} from "./grid";
import {VendingViewHeader} from "./header";
import {useLocalization} from "../i18n";

export interface CategoriesViewProps {
    categories: Category[];
    onCategory: (category: Category) => void;
    onPickupOrder: () => void;
}

export function CategoriesView({categories, onCategory, onPickupOrder}: CategoriesViewProps) {
    const {t} = useLocalization();
    return (
        <View>
            <VendingViewHeader button={t("PickupOrder")} onButtonClick={onPickupOrder}/>
            <GridViewContent>
                {categories.map((c) => <CategoryListItem key={c.id} category={c} onSelect={onCategory}/>)}
            </GridViewContent>
        </View>
    );
}

interface CategoryListItemProps {
    category: Category;
    onSelect: (category: Category) => void;
}

function CategoryListItem({category, onSelect}: CategoryListItemProps) {
    const handleClick = useCallback(() => onSelect(category), [category, onSelect]);
    return (
        <GridItem onClick={handleClick} image={category.image} text={category.name}/>
    );
}
